/**
 * <TutorStudentsTwoPane> — Mes élèves et la fiche ouverte, côte à côte au large (page).
 *
 * Le gabarit à deux volets (`<TwoPaneTemplate>`, seuil 1 100 px) habillé pour le masteur, comme
 * `<StudentCoachTwoPane>` l'est pour l'élève : à gauche Mes élèves, bornée au volet, la ligne ouverte
 * marquée ; à droite la fiche, sans retour. On passe d'un élève à l'autre sans revenir en arrière ; c'est
 * l'écran qui garde l'onglet ouvert d'un élève à l'autre. C'est aussi la messagerie du masteur : la
 * pastille d'un élève ouvre sa fiche sur Messages. En deçà du seuil, un écran à la fois, avec le retour.
 *
 * Contrôlée : la fiche ouverte arrive en props (`fiche`, ou `null`).
 */
import React from "react"

import { EmptyState } from "../../molecules/EmptyState"
import { TWO_PANE_LIST_WIDTH, TwoPaneTemplate } from "../../templates/TwoPaneTemplate"
import { TutorStudentProfilePage, type TutorStudentProfilePageProps } from "../TutorStudentProfilePage"
import { TutorStudentsPage, type TutorStudentsPageProps } from "../TutorStudentsPage"

const TEXTS = {
    emptyTitle: "Aucun élève ouvert",
    emptyMessage: "Choisis un élève dans la liste pour lire sa fiche.",
}

export type TutorStudentsTwoPaneProps = {
    /** Mes élèves, telle quelle : la liste. */
    students: Omit<TutorStudentsPageProps, "openStudentId" | "columnWidth">
    fiche: TutorStudentProfilePageProps | null
    /** L'élève ouvert : sa ligne reste marquée pendant que sa fiche charge. */
    openStudentId?: string | number | null
    testID?: string
}

export function TutorStudentsTwoPane(props: TutorStudentsTwoPaneProps) {
    const { students, fiche, openStudentId, testID } = props
    return (
        <TwoPaneTemplate
            testID={testID}
            list={(split) => (
                <TutorStudentsPage
                    {...students}
                    columnWidth={split ? TWO_PANE_LIST_WIDTH : undefined}
                    openStudentId={split ? (openStudentId ?? fiche?.profile?.student.id) : undefined}
                />
            )}
            detail={
                fiche == null
                    ? null
                    : (split) => <TutorStudentProfilePage {...fiche} onBack={split ? undefined : fiche.onBack} />
            }
            empty={<EmptyState iconName="user-graduate" title={TEXTS.emptyTitle} message={TEXTS.emptyMessage} />}
        />
    )
}
